var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('TabArchivedCourse'),_c('TableArchivedCourse'),_c('CourseDetial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }